import FirebaseContext, { withFirebase } from './context';
import Firebase from './firebaseClient';

export default Firebase;

export { FirebaseContext, withFirebase };
